import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DesktopShareContent from '../DesktopShareContent';
import { getDeviationResourceType, getTranslatedDeviationTitle, } from '../../../DeviationViews/_helpers';
import { getDeviationShareCodes } from '../../helpers';
import s from './DesktopShareModal.scss';
var DesktopShareModal = function (_a) {
    var deviation = _a.deviation, onRequestClose = _a.onRequestClose;
    var t = useTranslation().t;
    return (React.createElement(Modal, { heading: t('share.shareOnSocial'), onRequestClose: onRequestClose, contentClassName: s['root'], isOpen: true },
        React.createElement(DesktopShareContent, __assign({ title: getTranslatedDeviationTitle(deviation, t), biData: {
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
            } }, getDeviationShareCodes(deviation)))));
};
DesktopShareModal.displayName = 'DesktopShareModal';
export default DesktopShareModal;
//# sourceMappingURL=DesktopShareModal.js.map